import { useQuery } from '@tanstack/react-query';
import { apiFetch, ApiError } from '@/lib/api';
import type { DetailResponse } from '@/types/detail';

export function useBestellung(bestellnr: string) {
  return useQuery({
    queryKey: ['bestellung', bestellnr],
    queryFn: () =>
      apiFetch<DetailResponse>(
        `/bestellungen/detail.php?bestellnr=${encodeURIComponent(bestellnr)}`
      ),
    enabled: bestellnr !== '',
    // Eine Bestellung, die es nicht gibt, gibt es beim dritten Versuch
    // auch nicht. Ohne diese Zeile lief der Ladekreis erst durch zwei
    // Wiederholungen mit Wartezeit, bevor ueberhaupt etwas dastand (B97).
    retry: (anzahl, fehler) =>
      fehler instanceof ApiError && fehler.status === 404 ? false : anzahl < 2,
    staleTime: 0,
    refetchInterval: 30_000,
    refetchIntervalInBackground: false
  });
}
